function hideInvoices(contents){
  contents.forEach((content) => { 
    content.classList.add('hidden');
    var inputs = content.querySelectorAll('input') || [];
    inputs.forEach((input) => {
      input.removeAttribute('required');
      input.value = '';
    })
 });
}

function enableInvoices(element){
  element.classList.remove('hidden');
  var inputs = element.querySelectorAll('input[data-required="true"]') || [];
  inputs.forEach((input) => {
    input.setAttribute('required', 'required');
  });
}

function resetInvoices(){
  var contents = document.querySelectorAll('.invoice-type-content') || [];
  var checked = document.querySelector('input[name="invoicetype"]:checked');
  if(checked) checked.checked = false;

  if(contents.length == 0)
    return;

  contents.forEach((content) => {
    content.classList.add('hidden');
    var inputs = content.querySelectorAll('input') || [];
    inputs.forEach((input) => {
      input.removeAttribute('required');
      input.value = '';
    })
  });
}

var radios = document.querySelectorAll('input[name="invoicetype"]') || [];
radios.forEach((radio) => {
  radio.addEventListener('change', () => {
    var checked = document.querySelector('input[name="invoicetype"]:checked');
    var contents = document.querySelectorAll('.invoice-type-content') || [];

    if(contents.length == 0)
      return;

      hideInvoices(contents);
      
      var element = document.querySelector('#invoice-'+checked.value);
      enableInvoices(element);
    
  })
});


var expandButton = document.querySelector('.cart__widget--invoice [data-collapsible-trigger]');
if(expandButton){
  expandButton.addEventListener('click', (e) => {
    var isOpen = e.target.closest('details').getAttribute('open');
    //console.log(isOpen)
    if(!isOpen) return;
    resetInvoices();
  })
}
